<template>
  <div>
    <div class="explore">
      <module-renderer location="explore" :moduleData="moduleData" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'Explore',
  data() {
    return {
      exploreFetchComplete: false
    };
  },
  methods: {
    ...mapActions('assignments', ['getAssignments'])
  },
  computed: {
    ...mapGetters('assignments', { findAssignments: 'find' }),
    ...mapState(['offer', 'partnerUser']),
    moduleData() {
      if (!this.exploreFetchComplete) return [];
      const assignment = this.findAssignments(this.offer.id);
      return assignment?.modules || [];
    }
  },
  async mounted() {
    await this.getAssignments({
      assignmentId: this.offer.id,
      offerId: this.offer.id,
      location: 'explore',
      type: 'offer'
    });
    this.exploreFetchComplete = true;
  }
};
</script>

<style scoped lang="scss">
.expired-pass {
  filter: grayscale(1);
}
</style>
